import styled from "styled-components";

export const Box = styled.div`
  padding: 0.8rem;
  text-align: ${(props) => props.align};
  border-top: 1px solid ${(props) => props.theme.color.base.i500};
  border-bottom: 1px solid ${(props) => props.theme.color.base.i500};
`;
